var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var InlineImageComponent = function (props) {
    var _a = props.attrs, alt = _a.alt, src = _a.src, width = _a.width, height = _a.height, name = _a.name;
    return (React.createElement("img", __assign({ src: src, 
        // @ts-ignore
        name: name, alt: alt || '' }, (width ? { width: width.toFixed(2).replace(/\.?0+$/, '') } : {}), (height ? { height: height.toFixed(2).replace(/\.?0+$/, '') } : {}))));
};
var ImageComponent = function (props) {
    var _a = props.attrs, alt = _a.alt, align = _a.align;
    return (React.createElement("div", __assign({ className: "syl-image-wrapper" }, (align ? { align: align } : {})),
        React.createElement("span", { className: 'syl-image-fixer', style: { display: 'inline-block' } },
            InlineImageComponent(props),
            alt && alt.length > 0 && React.createElement("p", { className: "syl-image-caption" }, props.attrs.alt || ''))));
};
export { ImageComponent, InlineImageComponent };
//# sourceMappingURL=template.js.map